var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBank(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "nfv37g0bia",
    d: "M9.688 2.273v.34c0 .095-.07.171-.157.171h-.469v.256c0 .141-.104.255-.234.255H1.172c-.13 0-.234-.114-.234-.255v-.256h-.47c-.086 0-.156-.076-.156-.17v-.341c0-.07.039-.131.097-.158L4.94.24c.039-.017.081-.017.12 0L9.59 2.115c.058.027.097.089.097.158zm-.47 6.477H.782c-.259 0-.469.229-.469.511v.341c0 .094.07.17.157.17H9.53c.087 0 .156-.076.156-.17v-.34c0-.283-.21-.512-.468-.512zM1.564 3.636v4.091h-.391c-.13 0-.234.115-.234.256v.426h8.124v-.426c0-.141-.104-.256-.234-.256h-.39v-4.09h-1.25v4.09h-.625v-4.09h-1.25v4.09h-.625v-4.09h-1.25v4.09h-.626v-4.09h-1.25z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-948 -1481) translate(81 1463) translate(867 18)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 16,
    y: 4,
    fill: "#5CA37C",
    rx: 2
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(7 7)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#FFF",
    fillRule: "nonzero",
    xlinkHref: "#nfv37g0bia"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBank);
export default __webpack_public_path__ + "static/media/bank.7baff4911393d3bc6e8abd8a201c86c4.svg";
export { ForwardRef as ReactComponent };